module.exports = "<div class=\"text-center\" ng-if=\"!$ctrl.filterData.filterData.cells.length && !$ctrl.filterData.loading\n     && !$ctrl.filterData.cancelled\">{{::'Нет данных за период, попадающих под фильтр' | gettext}}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/stat/radar/radar.component.html
// module id = 439
// module chunks = 0